var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pull-refresh"},[_c('div',{staticClass:"pull-refresh__loader",style:({
    top: _vm.loaderTop + 'px',
    opacity: _vm.loaderTop * 2 / 100
  })},[_c('div',{staticClass:"pull-refresh__circle",class:{
        'pull-refresh__circle--animation': (_vm.loaderTop > 75)
      },style:({
        transform: 'rotate(' + (_vm.loaderTop + 100) + 'deg)'
      })})])])
}
var staticRenderFns = []

export { render, staticRenderFns }